import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'
import { Button } from 'ic-snacks'
import Modal from 'legacy/components/Modal/Modal'
import { DashText } from 'legacy/dash-blocks/dash-text/DashText'
import { dashColors } from 'legacy/dash-blocks/foundation/colors'
import { ImageUploader } from 'gin-and-tonic/containers/image-uploader/ImageUploader'
import clientEnv from 'utils/global/clientEnv'

const Ul = styled.ul`
  list-style: initial;
  color: ${dashColors.DANGER};
`

const Li = styled.li`
  margin-left: 15px;
`

interface Props {
  isOpen: boolean
  onChange: (url: string) => void
  onClose: () => void
}

interface State {
  imageUrl: null | string
}

class ImageUploaderModal extends React.Component<Props, State> {
  readonly state: State = {
    imageUrl: null,
  }

  handleUpload = (imageUrl: string) => {
    this.setState({
      imageUrl,
    })
  }

  handleChange = () => {
    const { onChange } = this.props
    const { imageUrl } = this.state

    imageUrl && onChange(imageUrl)
  }

  render() {
    const { onClose, isOpen } = this.props

    if (!isOpen) {
      return null
    }

    return (
      <Modal height="600px" width="600px" onClose={onClose}>
        {(Header: React.ComponentType, Body: React.ComponentType, Footer: React.ComponentType) => (
          <React.Fragment>
            <Header>
              <FormattedMessage id="catalog.product.image.edit" />
            </Header>
            <Body>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div
                  css={{
                    width: 215,
                    minHeight: 215,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <ImageUploader
                    filestackApiKey={clientEnv.PUBLIC_CLIENT_FILEPICKER_API_KEY}
                    value={this.state.imageUrl}
                    onChange={this.handleUpload}
                  />
                </div>
              </div>
              <DashText size="large" color="danger" weight="bold" elementType="span">
                <FormattedMessage id="catalog.product.editProduct.warning.title" />
              </DashText>
              <Ul>
                <Li>
                  <DashText color="danger">
                    <FormattedMessage
                      id="catalog.product.editProduct.warning.0"
                      values={{
                        productDetailsPage: (
                          <DashText weight="bold" elementType="span">
                            <FormattedMessage id="catalog.product.editProduct.warning.productDetailsPage" />
                          </DashText>
                        ),
                      }}
                    />
                  </DashText>
                </Li>
                <Li>
                  <DashText color="danger">
                    <FormattedMessage
                      id="catalog.product.editProduct.warning.1"
                      values={{
                        catalogFile: (
                          <DashText color="danger" weight="bold" elementType="span">
                            <FormattedMessage id="catalog.product.editProduct.warning.catalogFile" />
                          </DashText>
                        ),
                        productDetailsPage: (
                          <DashText weight="bold" elementType="span">
                            <FormattedMessage id="catalog.product.editProduct.warning.productDetailsPage" />
                          </DashText>
                        ),
                      }}
                    />
                  </DashText>
                </Li>
                <Li>
                  <DashText color="danger">
                    <FormattedMessage id="catalog.product.editProduct.warning.2" />
                  </DashText>
                </Li>
              </Ul>
            </Body>
            <Footer>
              <Button snacksStyle="secondary" onClick={onClose}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <div style={{ width: '20px' }} />
              <Button disabled={!this.state.imageUrl} onClick={this.handleChange}>
                <FormattedMessage id="common.confirm" />
              </Button>
            </Footer>
          </React.Fragment>
        )}
      </Modal>
    )
  }
}

export default ImageUploaderModal
